import { IntegrationsProvider } from './IntegrationsContext';

function IntegrationsProviderWrapper({ children }) {
  return <IntegrationsProvider>{children}</IntegrationsProvider>;
}

export default IntegrationsProviderWrapper;
